import { useContext, useEffect, useState } from "react";
import { ChatBody} from "./chat.styled";
import {
  ChatContainer,
  MessagesContentContainer,
  ChatBodyInnerContainer,
  UserInputWrapperDiv,
  HistoryBody,
} from "./chat.styled";
import { UserInput } from "./userInput";
import { Messages } from "./messages";
import { AuthContext } from "core/contexts/auth/auth";
import ChatHistory from "./history/history";
import ChatHistoryFull from "./history/chatHistoryFull";
import { usePreview } from "../store/previewContext";


interface MainChatAreaProps {
  apptheme: any;
  handleStartNewConversation: () => void;
  setConversationFromHistory: (id: string, model: string) => void;
  setShowCompleteHistory: (show: boolean) => void;
  showCompleteHistory: boolean;
  socket: any;
  convoState: any;
  onExcelUpload: (file: File) => void;
}

export const MainChatArea = ({
  apptheme,
  handleStartNewConversation,
  setConversationFromHistory,
  setShowCompleteHistory,
  showCompleteHistory,
  socket,
  convoState,
  onExcelUpload
}: MainChatAreaProps) => {

  const { amsUser } = useContext(AuthContext);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { previewContent, previewWidth } = usePreview();

  /**
   * Return the provider obj for the name
   */
  function getProviderByName(name: string) {
    if (convoState.providers !== null) {
      const provider = convoState.providers.find(
        (provider) => {
          return(provider !== undefined ? provider.name.trim().toLowerCase() === name.trim().toLowerCase() : null)
        }
      );

      if (provider) {
        return provider;
      } else {
        return {
          name: name,
          options: {
            accepts_text: true,
            accepts_files: false,
          },
        };
      }
    } else {
      return {
        name: name,
        options: {
          accepts_text: true,
          accepts_files: false,
        },
      };
    }
  }

  return (
    <div
      className={`${
        apptheme?.name === "dark-theme"
          && "bg-gradient-to-b from-gray-900 to-black"
      }`}
      style={{
        flexGrow: previewContent ? 100 - previewWidth : 50,
        flexShrink: 1,
        flexBasis: 0,
        overflow: "hidden",
        minWidth: isMenuOpen ? "300px": "47px",
        backgroundColor: apptheme?.name === "light-theme" && apptheme?.colors?.backgroundColor
      }}
    >
      <ChatContainer headerheight={"90px"}>
        {/* Chat history sidebar */}
        <HistoryBody
          ismenuopen={isMenuOpen.toString()}
          className="transition-all duration-500 ease-in-out"
        >
          <ChatHistory
            handleStartNewConversation={handleStartNewConversation}
            setConversationFromHistory={setConversationFromHistory}
            setShowCompleteHistory={setShowCompleteHistory}
            showCompleteHistory={showCompleteHistory}
            isMenuOpen={isMenuOpen}
            handleOpenMenu={setIsMenuOpen}
            socket={socket}
          />
        </HistoryBody>

        {/* Main chat body */}
        <ChatBody
          ismenuopen={isMenuOpen.toString()}
          className="bg-gray-200/10 border-slate-700 transition-all duration-300 ease-in-out block"
        >
          <ChatBodyInnerContainer className="chat-content">
            {showCompleteHistory ? (
              // Show full history view
              <ChatHistoryFull
                convoState={convoState}
                setConversationFromHistory={setConversationFromHistory}
                setShowCompleteHistory={setShowCompleteHistory}
              />
              
            ) : (
              // Show normal chat view
              <>
                {/* User/Response Message Area */}
                <div className="flex-grow-1 position-relative">
                  <MessagesContentContainer className="d-flex align-self-center justify-content-center">
                    <Messages
                      amsUser={amsUser}
                      containerWidthClasses={
                        isMenuOpen ? "col-md-10" : "col-md-10"
                      }
                    />
                  </MessagesContentContainer>
                </div>

                {/* User input area */}
                <UserInputWrapperDiv>
                  <UserInput
                    selectedProvider={getProviderByName(convoState.activeModel)}
                    socket={socket}
                    isMenuOpen={isMenuOpen}
                    onExcelUpload={onExcelUpload}
                  />
                </UserInputWrapperDiv>
              </>
            )}
          </ChatBodyInnerContainer>
        </ChatBody>
      </ChatContainer>
    </div>
  );
};
